export const navigationLinks = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Library",
    path: "/library",
  },
  {
    name: "Player",
    path: "#",
    dropdown: true,
    items: [
      {
        name: "WhatIsMysteryAct",
        path: "/what-is-mysteryact",
      },
      {
        name: "Online",
        path: "/online",
      },
      {
        name: "Offline",
        path: "/offline",
      }
    ]
  },
  {
    name: "StoreOwner",
    path: "#",
    dropdown: true,
    items: [
      {
        name: "BecomeAStoreOwner",
        path: "/store",
      },
      // {
      //   name: "GameMaster",
      //   path: "/host",
      // },
      {
        name: "StoreList",
        path: "/stores",
      }
    ]
  },
  {
    name: "Author",
    path: "#",
    external: true,
    customRedirect: 'author'
  },
  {
    name: "Help",
    path: "/help"
  }
];

export const otherLinks = [
  {
    name: "Community",
    path: "/community",
  },
  {
    name: "Blog",
    path: "/blog",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "Careers",
    path: "/careers",
  }
];
